import { render, staticRenderFns } from "./TTWYSYWIG.vue?vue&type=template&id=31ae30b8"
import script from "./TTWYSYWIG.vue?vue&type=script&lang=js"
export * from "./TTWYSYWIG.vue?vue&type=script&lang=js"
import style0 from "./TTWYSYWIG.vue?vue&type=style&index=0&id=31ae30b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports